import { Theme } from '@mui/material';
import { Components } from '@mui/material/styles/components';

export default function getComponents(theme: Theme): Components {
	return {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: '30px',
					textTransform: 'uppercase',
					padding: '10px 30px',
					fontWeight: 700,
				},
				contained: {
					color: theme.palette.primary.main,
					backgroundColor: 'white',
				},
				text: {
					color: 'white',
				},
			},
		},
		MuiTextField: {
			defaultProps: {
				variant: 'filled',
				fullWidth: true,
			},
		},
		MuiFormHelperText: {
			styleOverrides: {
				root: {
					'&.Mui-error': {
						color: theme.palette.text.primary,
					},
				},
			},
		},
		MuiFilledInput: {
			styleOverrides: {
				root: {
					backgroundColor: 'white',
					borderRadius: '30px',
					'&:hover': {
						backgroundColor: 'rgba(255, 255, 255, 0.7)',
					},
					'&.Mui-focused': {
						backgroundColor: 'white',
						boxShadow: '0 0 12px rgba(255, 255, 255, 0.7)',
					},
					'&.Mui-disabled': {
						backgroundColor: 'rgba(255, 255, 255, 0.7)',
					},
					// End override
					'&.Mui-error': {
						color: theme.palette.error.main,
					},
				},
				underline: {
					'&:after': {
						borderBottom: 'none',
						transform: 'unset',
					},
					'&.Mui-focused:after': {
						transform: 'unset',
					},
					'&.Mui-focused.Mui-error:after': {
						transform: 'unset',
					},
					'&:before': {
						borderBottom: 'none',
					},
					'&:hover:not(.Mui-disabled):before': {
						borderBottom: 'none',
					},
					'&.Mui-disabled:before': {
						borderBottom: 'none',
					},
				},
			},
		},
		MuiStepper: {
			styleOverrides: {
				root: {
					background: 'none',
					border: 'none',
				},
			},
		},
		MuiBackdrop: {
			styleOverrides: {
				root: {
					color: 'white',
				},
			},
		},
	};
}
